import { render } from "./createSurvey.vue?vue&type=template&id=0bcd2cae&scoped=true"
import script from "./createSurvey.vue?vue&type=script&lang=js"
export * from "./createSurvey.vue?vue&type=script&lang=js"

import "./createSurvey.vue?vue&type=style&index=0&id=0bcd2cae&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcd2cae"]])

export default __exports__